
export function decodeJwt(token) {
  if (!token) return { userId: null, role: null, userName: null };
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = JSON.parse(atob(base64));
    return {
      userId:
        json["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] ||
        json.sub ||
        null,
      role:
        json["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ||
        null,
      userName:
        json["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
        null,
    };
  } catch {
    return { userId: null, role: null, userName: null };
  }
}

// Если где-то нужно «сырой» payload целиком — оставь вспомогательную функцию:
export function decodeJwtRaw(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
